import Vue from "vue";
import firebase from "firebase/app";
import "firebase/auth";
import store from "./store";

const config = {
  apiKey:
    process.env.VUE_APP_FIREBASE_API_KEY ||
    "AIzaSyAfOkZAmtcX8QKjOlkESe_Tv8F-wkOienc",
  authDomain:
    process.env.VUE_APP_FIREBASE_AUTH_DOMAIN ||
    "harmonyservicecenter.firebaseapp.com"
};

firebase.initializeApp(config);
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

// Tokens are no longer stored; remove the one left behind by older builds
localStorage.removeItem("auth_token");

// Resolves once Firebase has restored (or failed to restore) the session
let resolveAuthReady;
export const authReady = new Promise(resolve => {
  resolveAuthReady = resolve;
});

firebase.auth().onAuthStateChanged(user => {
  const wasAuthenticated = store.getters["application/isAuthenticated"];
  store.commit("application/SET_AUTHENTICATED", !!user);
  resolveAuthReady();

  if (user && !wasAuthenticated) {
    store.dispatch("application/login");
  } else if (!user && wasAuthenticated) {
    // Session ended outside the app (e.g. revoked after a password reset)
    store.dispatch("application/logout");
  }
});

Vue.prototype.$firebase = firebase;
